module.exports = __webpack_public_path__ + "static/media/3_Line-Up-Template.089ba60e.svg";